// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"62d6513a","934":"e0db7bbe"}[chunkId] + ".chunk.js";
};